const linkConfig = {
  web: window.location.origin.replace("acat", "www"),
  h5: window.location.origin.replace("h5", "www"),
  online: "https://antofx.kf5.com/kchat/1040026",
  login: "https://fo.aatuser.com/Frontoffice",
  disclaimer:
    window.location.origin.indexOf("antohq") > 0
      ? window.location.origin.replace("acat", "www") + "/singlepage/disclaimer"
      : window.location.origin.replace("acat", "www") +
      "/singlepage?type=disclaimer",
  risk:
    window.location.origin.indexOf("antohq") > 0
      ? window.location.origin.replace("acat", "www") +
      "/singlepage/risk_disclosure"
      : window.location.origin.replace("acat", "www") +
      "/singlepage?type=risk_disclosure",
  agreement: window.location.origin.indexOf("antohq") > 0
    ? window.location.origin.replace("acat", "www") +
    "/singlepage/client_agreement"
    : window.location.origin.replace("acat", "www") +
    "/singlepage?type=client_agreement",
  policy: window.location.origin.indexOf("antohq") > 0
    ? window.location.origin.replace("acat", "www") +
    "/singlepage/privacy_policy"
    : window.location.origin.replace("acat", "www") +
    "/singlepage?type=privacy_policy",
};

const sourceUrl = "_s_u_l_";

export { linkConfig, sourceUrl };
